module.exports = __webpack_public_path__ + "img/85800.fcb19ca1.jpg";